import React, { useState } from 'react';
import { 
  Phone, 
  Mail, 
  MapPin, 
  ChevronRight,
  Truck,
  Shield,
  CreditCard
} from 'lucide-react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log('Subscribed with:', email);
    setEmail('');
    alert('Thank you for subscribing!');
  };
  return (
    <footer className="w-full bg-blue-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="space-y-4">
            <img 
              src="/image.png" 
              alt="DP Jewellers Logo" 
              className="h-16 md:h-20 w-auto object-contain"
            />
            <p className="text-gray-300 text-sm leading-relaxed">
              Crafting timeless elegance since 1941. DP Jewellers brings you the finest quality jewelry that celebrates life's precious moments.
            </p>
            <div className="flex space-x-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-orange-600 p-2 rounded-full transition-colors">
                <FaFacebook size={16} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-orange-600 p-2 rounded-full transition-colors">
                <FaInstagram size={16} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-orange-600 p-2 rounded-full transition-colors">
                <FaTwitter size={16} />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="bg-gray-800 hover:bg-orange-600 p-2 rounded-full transition-colors">
                <FaYoutube size={16} />
              </a>
            </div>
          </div>
          <div>
            <h3 className="text-orange-600 font-semibold text-lg mb-5 relative inline-block">
              Explore
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-orange-600 mt-1"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Home
                </a>
              </li>
              <li>
                <a href="/transformation" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Our Journey
                </a>
              </li>
              <li>
                <a href="/shop" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Shop
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Contact
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-orange-600 font-semibold text-lg mb-5 relative inline-block">
              Collections
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-orange-600 mt-1"></div>
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/goldjwellery" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Gold Jewellery
                </a>
              </li>
              <li>
                <a href="/dimondjewellery" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Diamond Jewellery
                </a>
              </li>
              <li>
                <a href="/silver" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Silver Articles
                </a>
              </li>
              <li>
                <a href="/necklaces" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Necklaces
                </a>
              </li>
              <li>
                <a href="/ring" className="text-gray-300 hover:text-orange-600 transition-colors text-sm flex items-center group">
                  <ChevronRight size={14} className="mr-2 opacity-0 group-hover:opacity-100 transition-opacity" />
                  Rings
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-orange-600 font-semibold text-lg mb-5 relative inline-block">
              Contact Info
              <div className="absolute bottom-0 left-0 w-12 h-0.5 bg-orange-600 mt-1"></div>
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-orange-600 mt-0.5" />
                <span className="text-gray-300 text-sm">NCC Tiraha, Tikhampur, Ballia, Uttar Pradesh 277001, India</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={16} className="text-orange-600" />
                <a href="tel:+918953786652" className="text-gray-300 text-sm hover:text-orange-600 transition-colors">089537 86652</a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={16} className="text-orange-600" />
                <a href="mailto:info@dpjewellersballia.in" className="text-gray-300 text-sm hover:text-orange-600 transition-colors">info@dpjewellersballia.in</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="max-w-2xl mx-auto text-center">
            <h3 className="text-orange-600 font-semibold text-xl mb-2">Subscribe to Our Newsletter</h3>
            <p className="text-gray-400 text-sm mb-4">Get exclusive offers, new arrivals, and jewelry tips straight to your inbox.</p>
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
              <input 
                type="email" 
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 px-4 py-2 text-sm bg-gray-800 border border-gray-700 rounded-md focus:outline-none focus:border-orange-600 text-white"
              />
              <button 
                type="submit"
                className="bg-orange-600 hover:bg-orange-700 px-6 py-2 rounded-md transition-colors text-sm font-semibold"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 bg-gray-900/50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-3 md:space-y-0">
            <div className="text-gray-400 text-xs">
              © {new Date().getFullYear()} DP Jewellers. All rights reserved. | Designed with ❤️ for jewelry lovers
            </div>
            <div className="flex space-x-5">
              <a href="/privacy-policy" className="text-gray-400 hover:text-orange-600 transition-colors text-xs">Privacy Policy</a>
              <a href="/terms" className="text-gray-400 hover:text-orange-600 transition-colors text-xs">Terms of Service</a>
              <a href="/payment" className="text-gray-400 hover:text-orange-600 transition-colors text-xs">Payment Terms</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;